<template>
  <v-container fluid class="px-0">
    <v-expansion-panels v-model="searchPanel" class="mb-0" v-if="!loadDefault">
      <v-expansion-panel>
        <v-expansion-panel-header>
          <v-row no-gutters>
            <v-col cols="4">
              Paieška
            </v-col>
          </v-row>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <form @keydown.enter.prevent="submit()">
            <v-row class="mb-3">
              <v-col cols="12" md="4">
                <el-text-field
                  label="Duomenų gavėjas"
                  v-model="extraData.wsa_duomenu_gavejas"
                />
              </v-col>
              <v-col cols="12" md="4">
                <el-text-field label="IP" v-model="extraData.wsa_ip" />
              </v-col>
              <v-col cols="12" md="4">
                <el-text-field
                  label="Parametrai"
                  v-model="extraData.wsa_parametrai"
                />
              </v-col>

              <v-col cols="12" md="6">
                <el-date-picker
                  label="Užklausos data nuo"
                  v-model="extraData.wsa_sukurimo_data_nuo"
                />
              </v-col>
              <v-col cols="12" md="6">
                <el-date-picker
                  label="Užklausos data iki"
                  v-model="extraData.wsa_sukurimo_data_iki"
                />
              </v-col>
            </v-row>

            <v-row no-gutters>
              <v-col cols="12">
                <el-button primary @click.native.stop="searchData()">
                  Ieškoti
                </el-button>
                <el-button @click.native="clearData()">
                  Išvalyti
                </el-button>
              </v-col>
            </v-row>
          </form>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'AdminBrokerDetailSearch',
  props: {
    loading: Boolean,
  },
  data: () => ({
    searchPanel: null,
    loadDefault: null,
    mainData: {},
    extraData: {},
  }),
  computed: {
    ...mapGetters(['searchParams']),
    isExpanded() {
      return this.searchPanel === 0
    },
  },
  inject: {
    $validator: '$validator',
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      this.loadDefault = true

      if (this.searchParams && this.searchParams.route === this.$route.name) {
        this.mainData = this.searchParams.mainData
        this.extraData = this.searchParams.extraData
        this.searchPanel = this.searchParams.isExpanded ? 0 : null
      }

      this.searchData()
      this.loadDefault = false
    },
    searchData() {
      let searchData = {
        ...this.mainData,
        ...this.extraData,
      }

      this.$store.dispatch('searchParams', {
        route: this.$route.name,
        mainData: this.mainData,
        extraData: this.extraData,
        isExpanded: this.isExpanded,
      })

      this.$emit('search', searchData)
    },
    clearData() {
      this.mainData = {}
      this.extraData = {}
    },
    submit() {
      this.searchData()
    },
    clearRusis() {
      this.extraData.obj_tipas = []
    },
  },
}
</script>
